import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setAppSidebarWidth } from "../../../ReduxToolkit/Reducers/Messenger/AppSidebar";
import AppList from "./AppList";
import FileSection from "./FileSection";
import Music from "./Music";
import Notes from "./Notes";
import Reminder from "./Reminder";
import ToDo from "./ToDo";
import Video from "./Video";

const AppSidebarChat = () => {
  const { appSidebarActiveTab, appSidebarWidth } = useAppSelector((state) => state.appSidebar);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const updateSize = () => dispatch(setAppSidebarWidth(window.innerWidth));
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, [dispatch]);

  useEffect(() => {
    if (appSidebarWidth < 1500) document.querySelector(".chatzy-main")?.classList.add("small-sidebar");
    if (appSidebarWidth > 992) {
      document.querySelector(".app-sidebar")?.classList.add("active");
      document.querySelector(".main-nav")?.classList.add("on");
      document.querySelector(".chatzy-main")?.classList.add("small-sidebar");
      document.body.classList.add("sidebar-active", "main-page");
    }
    if (appSidebarWidth <= 992){
      document.body.classList.remove("sidebar-active");
      document.querySelector(".chatzy-main")?.classList.remove("small-sidebar");
      document.querySelector(".main-nav")?.classList.remove("on");
      document.querySelector(".app-sidebar")?.classList.remove("active");
    }else document.querySelector(".main-nav")?.classList.add("on");
  }, [appSidebarWidth]);

  return (
    <aside className="app-sidebar active">
      <div className="apps">
        <ul className="apps-ul">
          <li id="file" className={appSidebarActiveTab === "file" ? "active" : ""}><FileSection /></li>
          <li id="notes" className={appSidebarActiveTab === "notes" ? "active" : ""}><Notes /></li>
          <li id="todo" className={appSidebarActiveTab === "todo" ? "active" : ""}><ToDo /></li>
          <li id="music" className={appSidebarActiveTab === "music" ? "active" : ""}><Music /></li>
          <li id="video" className={appSidebarActiveTab === "video" ? "active" : ""}><Video /></li>
          <li id="reminder" className={appSidebarActiveTab === "reminder" ? "active" : ""}><Reminder /></li>
        </ul>
      </div>
      <AppList />
    </aside>
  );
};

export default AppSidebarChat;
